import { useTranslation } from 'next-i18next';
import React, { ReactNode, useEffect, useRef, useState } from 'react';

import DotsMenu from '~/images/shared/DotsMenu.svg';

interface Props<T> {
  list: T[];
  getTitle: (item: T) => string | ReactNode;
  getAction: (item: T) => () => void;
  getId?: (item: T) => string;
  onOpen: () => void;
  id?: string;
  DotsMenuIcon?: React.ReactNode;
}

export default function DotedMenu<T>({
  list,
  getAction,
  getTitle,
  getId,
  onOpen,
  id = 'doted_menu_id',
  DotsMenuIcon,
}: Props<T>) {
  const [showMenu, setShowMenu] = useState(false);
  const {
    i18n: { language },
  } = useTranslation('common');
  const dropdown = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!showMenu) return;

    if (showMenu) onOpen();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function handleClick(event: { target: any }) {
      if (dropdown.current && !dropdown.current.contains(event.target)) {
        setShowMenu(false);
      }
    }

    window.addEventListener('click', handleClick, { capture: true });
    return () => window.removeEventListener('click', handleClick);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showMenu]);

  return (
    <div className='relative h-fit'>
      <button
        id={id}
        onClick={(e) => {
          e.target;
          e.stopPropagation();
          setShowMenu((s) => !s);
        }}
      >
        {DotsMenuIcon ? DotsMenuIcon : <DotsMenu />}
      </button>
      {showMenu && (
        <div
          ref={dropdown}
          className={`absolute top-full ${
            language === 'ar' ? 'left-1/2' : 'right-1/2'
          } z-20 flex w-fit flex-col gap-1 overflow-hidden rounded-xl bg-white shadow-200`}
        >
          {list?.map((item) => (
            <button
              id={getId ? getId(item) : ''}
              key={getId ? getId(item) : ''}
              onClick={(e) => {
                e.stopPropagation();
                setShowMenu(false);
                getAction(item)();
              }}
              className=' px-20 py-16 text-14 text-primary-default'
            >
              {getTitle(item)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
